module.exports = __webpack_public_path__ + "img/dietTyerapyPdf.2c66144a.jpg";